import ChartHover from "./ChartHover.jsx";
import Breadcrumbs from "./Breadcrumbs.jsx";
import {useDispatch, useSelector} from "react-redux";
import {getUpdateKey} from "../../../ducks/chart-duck.js";
import './Dashboard.scss'
import Subnav from "./Subnav.jsx";
import Addendum from "./Addendum.jsx";
import Toggle from "../../util/Toggle.jsx";
import DatePicker from "./DatePicker.jsx";
import {getIsSingleAsset, setIsAllAssetListGrouped} from "../../../ducks/assets-duck.js";
import {useAssets} from "../asset-list/use-assets.js";
import TuneVariantIcon from "mdi-react/TuneVariantIcon.js";
import {activateWidePopup} from "../../../ducks/popup-duck.js";
import AssetSettings from "../../settings/AssetSettings.jsx";

export default () => {
    const dispatch = useDispatch()
    const updateKey = useSelector(getUpdateKey)
    const {
        isAllAssetList,
        isAllAssetListGrouped,
    } = useAssets()
    const isSingleAsset = useSelector(getIsSingleAsset)
    return (
        <>
            <div className='dashboard' id='dashboard'>
                <ChartHover key={updateKey}/>
                <Breadcrumbs/>
            </div>
            <Addendum>
                <Subnav/>
                {!isSingleAsset &&
                <>
                    <button
                        className='asset-settings'
                        onClick={() => dispatch(activateWidePopup(<AssetSettings/>))}
                    >
                        <TuneVariantIcon/>
                        <div className='hide-portrait'>
                            settings
                        </div>
                    </button>
                    {isAllAssetList &&
                    <div className='group-assets-toggle children-slide-right'>
                        <Toggle
                            isChecked={isAllAssetListGrouped}
                            onChange={value => dispatch(setIsAllAssetListGrouped(value))}
                        >
                            <div className='hide-portrait'>
                                group
                            </div>
                        </Toggle>
                    </div>
                    }
                    <DatePicker/>
                </>
                }
            </Addendum>
        </>
    )
}